import { createFileRoute } from "@tanstack/react-router";
import { AgentsPage } from "@/modules/agents/AgentsPage";

export const Route = createFileRoute("/_app/agents")({
  component: AgentsPage,
});
